import * as React from 'react'
import { useMediaQuery, useTheme } from '@material-ui/core'
import { MainTitle } from '@root/src/components/Typography'
import { Col, Grid, Row } from 'atomic'
import { navigate } from 'gatsby'
import TitleWithBreadcrumbRow from '../org.title-with-breadcrumb-row/title-with-breadcrumb-row.component'
import {
  VaccinesPackagesWrapper,
  CardsContainer,
  CardRow,
  Card,
  VaccinesCardsText,
  CardTitle,
  CardValue,
  VaccinesPackagesWrapperFilter,
  PackageTextFilter
} from './text-list-vaccines-page.style'

interface TextListPageProps {
  location: Location
  pageData: TextListPageData
  vaccinesClassification: any
  setVaccinesClassification: any
  handleClickFilter: any
  loading?: boolean
  featuredVaccines?: {
    titulo: string
    slug: string
    value: string
    isFeatured: Boolean
    packages: string[]
    classification?: string
    category?: string
  }[]
  children: JSX.Element | JSX.Element[]
}

export interface TextListItem {
  titulo: string
  slug: string
  value: string
  isFeatured: string
  packages: string[]
  synonyms: string[]
  category: string
}

export interface TextListPageData {
  title: string
  searchPlaceholder: string
  selectPlaceholder: string
  getItems: (startIndex: number, endIndex: number) => TextListItem[]
  itemsCount: number
  showItemCount: boolean
  col2Title: string
  col2ContentHtml: string
}

export const TextListHeader: React.FunctionComponent<any> = props => <>{props.children}</>
TextListHeader.displayName = 'TextListHeader'

export const TextListFooter: React.FunctionComponent<any> = props => <>{props.children}</>
TextListFooter.displayName = 'TextListFooter'

export const TextListPage: React.FunctionComponent<TextListPageProps> = props => {
  const pageData = props.pageData
  const featuredVaccines = props.featuredVaccines
  const theme = useTheme()
  const downOfMd = useMediaQuery(theme.breakpoints.down('sm'))

  const getChildByDisplayName = (children: React.ReactNode, displayName: string) =>
    React.Children.map(children, (child: any) =>
      child && child.type && child.type.displayName === displayName ? child : null
    )

  const cleanCategory = (s: string) => String(s || '').replace(/<[^>]*>/g, '')
  const source = (featuredVaccines || []).map(v => ({ ...v, category: cleanCategory((v as any).category || '') }))

  const vaccinesByCategory = source.reduce((acc, vaccine) => {
    const category = vaccine.category || 'Sem Categoria'
    if (!acc[category]) acc[category] = []
    acc[category].push(vaccine)
    return acc
  }, {} as Record<string, typeof source>)

  const adjustMarginTop = downOfMd
    ? process.env.GATSBY_COSMIC_BUCKET?.toLowerCase() === 'weinmann'
      ? 100
      : 0
    : 0

  const header = getChildByDisplayName(props.children, TextListHeader.displayName)
  const footer = getChildByDisplayName(props.children, TextListFooter.displayName)

  const destaqueCategory = vaccinesByCategory['Destaques']
  const otherCategories = Object.entries(vaccinesByCategory).filter(([category]) => category !== 'Destaques')

  return (
    <Grid style={{ marginTop: adjustMarginTop }} maxWidth={false}>
      <TitleWithBreadcrumbRow />
      <Row style={{ marginLeft: '2px', marginTop: '-24px', marginBottom: '16px' }}>
        <MainTitle variant="h2">{pageData.title}</MainTitle>
      </Row>
      {header}
      <Row mb>
        <Col xs={12} md={3}>
          <VaccinesPackagesWrapperFilter>
            {props.vaccinesClassification?.map((item, index) => (
              <PackageTextFilter
                key={item.classification}
                onClick={() => props.handleClickFilter(index)}
                isSelected={item.selected}
              >
                {item.name}
              </PackageTextFilter>
            ))}
          </VaccinesPackagesWrapperFilter>
        </Col>
        <Col xs={12} md={9}>
          {Object.keys(vaccinesByCategory).length === 0 ? (
            <VaccinesPackagesWrapper>
              <span
                style={{
                  display: 'block',
                  fontSize: '16px',
                  color: '#666',
                  fontWeight: 'normal',
                  marginTop: '8px',
                  textAlign: 'center',
                  padding: '32px'
                }}
              >
                Nenhum resultado foi encontrado
              </span>
            </VaccinesPackagesWrapper>
          ) : (
            <>
              {destaqueCategory && (
                <VaccinesPackagesWrapper key="Destaques">
                  <VaccinesCardsText style={{ textAlign: 'left' }}>
                    Destaques
                  </VaccinesCardsText>
                  <CardsContainer>
                    <CardRow>
                      {destaqueCategory.map((item, index) => (
                        <Card key={index} onClick={() => navigate(`/vacinas/${item.slug}`)}>
                          <CardTitle>{item.titulo}</CardTitle>
                          <CardValue>R$ {item.value}</CardValue>
                        </Card>
                      ))}
                    </CardRow>
                  </CardsContainer>
                </VaccinesPackagesWrapper>
              )}

              {otherCategories.map(([category, vaccines]) => (
                <VaccinesPackagesWrapper key={category}>
                  <VaccinesCardsText style={{ textAlign: 'left' }}>
                    {category}
                  </VaccinesCardsText>
                  <CardsContainer>
                    <CardRow>
                      {vaccines.map((item, index) => (
                        <Card key={index} onClick={() => navigate(`/vacinas/${item.slug}`)}>
                          <CardTitle>{item.titulo}</CardTitle>
                          <CardValue>R$ {item.value}</CardValue>
                        </Card>
                      ))}
                    </CardRow>
                  </CardsContainer>
                </VaccinesPackagesWrapper>
              ))}
            </>
          )}
        </Col>
        <Col xs={12} md={8}>
          {footer}
        </Col>
      </Row>
    </Grid>
  )
}
